<template>
  <div :class="$style.container">
    <!-- <BaseIcon
      v-if="backButton"
      name="chevron-left"
      :class="$style.actionButton"
      @click="back"
    /> -->
    <div :class="$style.content">
      <slot name="default" />
    </div>
    <div :class="$style.action">
      <slot name="action" />
      <v-popover
        v-if="menuOptions"
        placement="bottom-start"
        popoverClass="no-arrow"
      >
        <div :class="['tooltip-target', 'action-button']">
          <BaseIcon custom name="ellipsisX" />
        </div>
        <MenuBase
          slot="popover" v-close-popover
          :options="menuOptions"
        />
      </v-popover>
    </div>
  </div>
</template>

<script>
import MenuBase from './MenuBase'

export default {
  name: 'info-header',
  components: {
    MenuBase
  },
  props: {
    backButton: {
      type: Boolean,
      default: true
    },
    menuOptions: Array
  },
  methods: {
    hasHistory () {
      return window.history.length > 2
    },
    back () {
      this.hasHistory()
        ? this.$router.go(-1)
        : this.$router.push({ name: 'app-blogs' })
    }
  }
}
</script>

<style module lang="scss">
$height: 48px;

.container {
  height: $height;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 8px;
  min-height: 0;
}
.content {
  flex-grow: 1;
  font-size: 16px;
  margin-left: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.action {
  display: flex;
  height: $height;
  font-size: 20px;
  align-items: center;
  :global(.action-button) {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    // width: 25px;
    // height: 48px;
    margin-left: 16px;
    color: $text-mid;
    // font-size: 18px;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
